import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['deleteForm'];

  open(event) {
    const deleteUrl = event.detail?.deleteUrl;
    if (deleteUrl) {
      this.deleteFormTarget.action = deleteUrl;
    }
    $(this.element).modal();
  }
}
